/**
 * Where the home create flow is: composing, uploading, retrying a delivery, offering an unfinished upload,
 * telling the sender one is over, or showing a send's result.
 */
export type CreatePhaseName = "create" | "progress" | "deliveryRetry" | "resume" | "abandoned" | "success";

/** What an arriving ask does to the create flow. */
export type ComposerArrival = "open" | "closeSuccessThenOpen" | "waitForComposer";

/**
 * What an ask from the Transfers sheet does to the home panel it arrives at: the Requested tab's new request
 * (kitecorp/transferify-ui#3140, owner 2026-10-01, option a) and the Files tab's new link to stored files
 * (kitecorp/transferify-ui#3405) follow one rule. React-free.
 *
 * On the composer, the asked-for mode opens at once. A send's success card the sender has already seen closes,
 * as Send another closes it, and the asked-for mode opens on the composer it leaves. An upload or a delivery retry
 * is never interrupted: the ask waits until the sender is back on the composer, which a finished upload's
 * success card is not, so its Send another is what opens the asked-for mode then.
 */
export function composerArrival(phase: CreatePhaseName): ComposerArrival {
	switch (phase) {
		case "create":
			return "open";
		case "success":
		case "abandoned":
			return "closeSuccessThenOpen";
		case "progress":
		case "deliveryRetry":
		case "resume":
			return "waitForComposer";
	}
}
